<template>
  <div>
    <div v-if="loading">
    `  <div class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
      </div>
    </div>
    <div v-else>
      <div class="banner-image-container">
        <img class="banner-image" v-if="viewUser.bg_img" :src="viewUser.bg_img[0].url" alt />
        <img v-else src="https://mycircle-prod.s3.amazonaws.com/default-profile-bg-img1698993539.jpg" alt="background" class="default-profile-bg-img" />
      </div>
      <div class="dovemed-wrapper m-mw-100">
        <div class="profile-card-container">
          <ProfileCompletenessView :user="viewUser" :circlesOn="circlesOn" :MembersOnCircles="MembersOnCircles" :fetch="init" />
        </div>
        <div class="profile-tab sort-dropdown">
          <div
            :style="this.$route.path.includes('updates') ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
            id="updates"
            :class="this.$route.path.includes('updates') ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
          >
            Updates
          </div>
          <div
            :style="this.$route.path.includes('about') ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
            id="story"
            :class="this.$route.path.includes('about') ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
          >
            Story
          </div>
          <div
            :style="this.$route.path.includes('dovedaily') ? { color: getPrimaryColor(), background: getPrimary50Color() } : { color: '#0F1734' }"
            id="dovedaily"
            :class="this.$route.path.includes('dovedaily') ? 'active-tabs' : 'tabs'"
            @click="handletab($event)"
            v-if="viewUser.role === 'patient' || viewUser.role === 'caregiver'"
          >
            DoveDaily
          </div>
          <div
            :style="
              this.$route.path.includes('ViewAllCircle') ||
              this.$route.path.includes('self') ||
              this.$route.path.includes('hospitals') ||
              this.$route.path.includes('clinics') ||
              this.$route.path.includes('nfp') ||
              this.$route.path.includes('hcp') ||
              this.$route.path.includes('providers')
                ? { color: getPrimaryColor(), background: getPrimary50Color() }
                : { color: '#0F1734' }
            "
            id="circles"
            :class="
              this.$route.path.includes('ViewAllCircle') ||
              this.$route.path.includes('self') ||
              this.$route.path.includes('hospitals') ||
              this.$route.path.includes('clinics') ||
              this.$route.path.includes('nfp') ||
              this.$route.path.includes('hcp') ||
              this.$route.path.includes('providers')
                ? 'active-tabs'
                : 'tabs'
            "
            @click="handletab($event)"
          >
            Circles
          </div>
          <a-dropdown :trigger="['click']" :getPopupContainer="trigger => trigger.parentNode" v-model="displayDots2" :disabled="$refs.drawerMenuRef.isMobile">
            <div
              @click="() => {$refs.drawerMenuRef.isMobile ? $refs.drawerMenuRef.show() : null}"
              :style="
                this.$route.path.includes('muteduser') ||
                this.$route.path.includes('qa') ||
                this.$route.path.includes('polls') ||
                this.$route.path.includes('saved') ||
                this.$route.path.includes('profilerev') ||
                this.$route.path.includes('medrev') ||
                this.$route.path.includes('profilercmnd') ||
                this.$route.path.includes('treatmentrcmnd')
                  ? { color: getPrimaryColor(), background: getPrimary50Color() }
                  : { color: '#0F1734' }
              "
              id="reviews"
              :class="
                this.$route.path.includes('muteduser') ||
                this.$route.path.includes('qa') ||
                this.$route.path.includes('polls') ||
                this.$route.path.includes('saved') ||
                this.$route.path.includes('profilerev') ||
                this.$route.path.includes('medrev') ||
                this.$route.path.includes('profilercmnd') ||
                this.$route.path.includes('treatmentrcmnd')
                  ? 'active-tabs'
                  : 'tabs'
              "
            >
              <div
                :style="
                  this.$route.path.includes('muteduser') ||
                  this.$route.path.includes('qa') ||
                  this.$route.path.includes('polls') ||
                  this.$route.path.includes('saved') ||
                  this.$route.path.includes('profilerev') ||
                  this.$route.path.includes('medrev') ||
                  this.$route.path.includes('profilercmnd') ||
                  this.$route.path.includes('treatmentrcmnd')
                    ? { color: getPrimaryColor() }
                    : ''
                "
                class="tabe"
              >
                <!-- {{ selectedTab }} -->
                {{ "Reviews & More" }}
                <font-awesome-icon size="1x" :icon="displayDots2 ? ['far', 'angle-up'] : ['far', 'angle-down']" class="mr-2" />
              </div>
            </div>
            <template #overlay>
              <a-menu>
                <a-menu-item
                  id="qa"
                  @click="
                    () => {
                      selectedTab = 'Q&A'
                      $router.push({ name: 'ViewPatientQA' })
                    }
                  "
                  class="card-item"
                >
                  Q&A
                </a-menu-item>
                <a-menu-item
                  id="polls"
                  @click="
                    () => {
                      selectedTab = 'Polls'
                      $router.push({ name: 'ViewPatientPolls' })
                    }
                  "
                  class="card-item"
                >
                  Polls
                </a-menu-item>
                <a-menu-item
                  id="saved"
                  @click="
                    () => {
                      selectedTab = 'Saved'
                      $router.push({ name: 'ViewPatientFavorites' })
                    }
                  "
                  class="card-item"
                >
                  Saved
                </a-menu-item>
                <a-menu-item
                  id="medrev"
                  @click="
                    () => {
                      selectedTab = 'Medication Reviews'
                      $router.push({ name: 'viewPatientMedReview' })
                    }
                  "
                  class="card-item"
                >
                  Medication Reviews
                </a-menu-item>
                <a-menu-item
                  id="treatmentrcmnd"
                  @click="
                    () => {
                      selectedTab = 'Treatment Recommendations'
                      $router.push({ name: 'viewPatientTreatmentRec' })
                    }
                  "
                  class="card-item"
                >
                  Treatment Recommendations
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
        <div class="child-tab-view">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <DrawerModal ref="drawerMenuRef">
      <div @click="() => $refs.drawerMenuRef.close()">
          <a-menu-item
            id="qa"
            @click="
              () => {
                selectedTab = 'Q&A'
                $router.push({ name: 'ViewPatientQA' })
              }
            "
            class="drawer-item"
          >
            Q&A
          </a-menu-item>
          <a-menu-item
            id="polls"
            @click="
              () => {
                selectedTab = 'Polls'
                $router.push({ name: 'ViewPatientPolls' })
              }
            "
            class="drawer-item"
          >
            Polls
          </a-menu-item>
          <a-menu-item
            id="saved"
            @click="
              () => {
                selectedTab = 'Saved'
                $router.push({ name: 'ViewPatientFavorites' })
              }
            "
            class="drawer-item"
          >
            Saved
          </a-menu-item>
          <a-menu-item
            id="medrev"
            @click="
              () => {
                selectedTab = 'Medication Reviews'
                $router.push({ name: 'viewPatientMedReview' })
              }
            "
            class="drawer-item"
          >
            Medication Reviews
          </a-menu-item>
          <a-menu-item
            id="treatmentrcmnd"
            @click="
              () => {
                selectedTab = 'Treatment Recommendations'
                $router.push({ name: 'viewPatientTreatmentRec' })
              }
            "
            class="drawer-item"
          >
            Treatment Recommendations
          </a-menu-item>
        </div>
    </DrawerModal>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import ProfileCompletenessView from "../../../commons/ProfileCompletenessView.vue"
import DrawerModal from "../../../Modals/DrawerModal.vue"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PatientProfile",
  components: {
    ProfileCompletenessView,
    DrawerModal,
  },
  data() {
    return {
      user: null,
      addToCircleInProgress: false,
      displayDots: false,
      displayDots2: false,
      selectedTab: "Reviews & More",
      loading: true,
    }
  },
  created() {
    const role = this.$route.params.role ? this.$route.params.role : 'patient'
    if (
      Number(this.$route.params.id) === this.authUser.user.id &&
      role === this.authUser.user.role
    ) {
      this.routeToAuthProfile(this.authUser.user.role);
    } else {
      console.warn("ViewPatientProfile.vue is created");
      console.log("viewUser:", this.viewUser);
      this.init();
      window.addEventListener("mouseup", () => {
        // if (this.displayDots2) {
        //   setTimeout(() => {
        //     this.displayDots2 = false
        //   }, 100)
        // }
        if (this.displayDots) {
          setTimeout(() => {
            this.displayDots = false;
          }, 100);
        }
      });
    }
  },
  watch: {
    selectedTab: {
      handler() {
        this.displayDots2 = false
      },
      immediate: true,
    },
    "$route.params.id": {
      handler() {
        this.loading = true;
        window.location.reload();
      },
    },
  },
  methods: {
    handletab(event) {
      // console.log(event.target.id)
      this.displayDots2 = false
      switch (event.target.id) {
        case "updates":
          this.selectedTab = "Reviews & More"
          this.$router.push({ name: "ViewPatientUpdates" })
          break
        case "story":
          this.selectedTab = "Reviews & More"
          this.$router.push({ name: "ViewPatientAbout" })
          break
        case "dovedaily":
          this.selectedTab = "Reviews & More"
          this.$router.push({ name: "ViewPatientDoveDaily" })
          break
        case "circles":
          this.selectedTab = "Reviews & More"
          this.$router.push({
            path: `/${this.currentCircle.key_name}/profile/view/${this.viewUser.role}/${this.viewUser.id || this.viewUser.ext_ref_id}/circles/ViewAllCircle`,
          })
          break
        case "qa":
          this.$router.push({ name: "ViewPatientQA" })
          break
        case "saved":
          this.$router.push({ name: "ViewPatientFavorites" })
          break
        default:
          this.$router.push({ name: "ViewPatientAbout" })
          break
      }
    },

    init() {
      console.log("inside init()")
      this.loading = true;
      UserRepository.getOtherUserProfile({id: this.$route.params.id, role: this.$route.params.role ? this.$route.params.role: 'patient'}, this.currentCircle.id)
        .then(res => {
          const data = {
            ...res.data.data.user_info,
            on_circle: res.data.data.on_circle,
            request_to_add: res.data.data.request_to_add,
            no_of_members: res.data.data.no_of_members,
          }
          this.$store.commit("User/setViewUser", { data })
          this.circlesOn = res.data.data.no_of_circle_on
          this.MembersOnCircles = res.data.data.no_of_members
          this.loading = false;
        })
        .catch(err => this.loading = false)
    },

    addToCircle() {
      this.addToCircleInProgress = true
      UserRepository.addToCircle(this.viewUser, this.currentCircle.id)
        .then(res => {
          UserRepository.getOtherUserProfile(this.viewUser, this.currentCircle.id)
            .then(res => {
              const data = {
                ...res.data.data.user_info,
                on_circle: res.data.data.on_circle,
                request_to_add: res.data.data.request_to_add,
                no_of_members: res.data.data.no_of_members,
              }
              this.$store.commit("User/setViewUser", { data })
              this.init()
              this.addToCircleInProgress = false
            })
            .catch(err => {
              this.addToCircleInProgress = false
            })
        })
        .catch(err => {
          this.addToCircleInProgress = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.tabe {
  display: flex;
  gap: 5px;
  align-items: center;
  width: max-content;
}

.card-item {
  font-weight: 400 !important;
  font-size: 16px !important;
  margin-left: 0 !important;
  line-height: 32px;
  color: #1e2945;
  display: flex;
  align-items: center;
  gap: 10px;
}

.child-tab-view {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  position: absolute;
  width: 790px;
  left: 400px;
  top: 528px;

  @media screen and (max-width: 700px) {
    position: absolute;
    top: 850px;
    width: 100%;
    left: 0px;
    padding: 16px;
    align-items: center;
  }
}

.tabs:hover {
  color: #2a71d4;
}

.active-tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}

.tabs {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  height: 48px;
  border-radius: 6px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
}

.profile-tab {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  width: 732px;
  height: 48px;
  left: 400px;
  top: 432px;

  @media screen and (max-width: 700px) {
    top: 770px;
    left: 20px;
    overflow-x: scroll;
    width: 100%;
    padding-right: 38px;
    height: 410px;
  }
}

.profile-tab::-webkit-scrollbar {
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.profile-card-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 24px;
  position: absolute;
  width: 383px;
  top: 337px;
  background: #ffffff;
  box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  height: 600px;

  @media screen and (max-width: 700px) {
    padding: 16px;
    box-shadow: none;
    position: relative;
    align-items: baseline;
    height: 0px;
    left: 0px;
    top: 0px;
    width: 100%;
    background: none;
  }
}

.banner-image-container {
  width: 100%;
}

.banner-image {
  position: absolute;
  width: 100%;
  height: 400px;
  left: 0px;
  // top: 65px;
  object-fit: cover;
  @media screen and (max-width: 700px) {
    width: 100%;
    height: 187px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/view/ViewPatientProfile.vue